import { Currency } from '../CurrencySelectDialog';

interface GetCurrencyOptions {
    currencies: Currency[];
    selectedCurrencyCode: string;
    suggestedCurrencyCodes: string[];
}

export const getCurrencyOptions = ({
    currencies,
    selectedCurrencyCode,
    suggestedCurrencyCodes,
}: GetCurrencyOptions) => {
    const selectedCurrency = currencies.find(({ code }) => code === selectedCurrencyCode);
    const currenciesWithoutSelectedCurrency = currencies.filter(({ code }) => code !== selectedCurrencyCode);

    const suggestedCurrencyOptions = currenciesWithoutSelectedCurrency.filter((currency) =>
        suggestedCurrencyCodes.includes(currency.code)
    );

    const otherCurrencyOptions = currenciesWithoutSelectedCurrency.filter(
        (currency) => !suggestedCurrencyCodes.includes(currency.code)
    );

    if (selectedCurrency) {
        otherCurrencyOptions.unshift(selectedCurrency);
    }

    return {
        suggestedCurrencyOptions,
        otherCurrencyOptions,
    };
};
